export default __webpack_public_path__ + "static/media/pantry2-before2.36c05236.jpg";